export const clientBasicTypes = {
  GET_CLIENT_BASIC_REQUEST: "GET_CLIENT_BASIC_REQUEST",
  GET_CLIENT_BASIC_SUCCESS: "GET_CLIENT_BASIC_SUCCESS",
  GET_CLIENT_BASIC_FAILURE: "GET_CLIENT_BASIC_FAILURE"
}